const hubspotRepository = (fetch: CustomFetch) => ({
  async sendData(portalId: string, formId: string, data: Record<string, unknown>) {
    const url = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`

    await fetch(url, {
      method: 'POST',
      body: data,
      // Signup completion pages navigate away right after the call; keepalive lets the request finish
      keepalive: true,
    })
  },
})

export default hubspotRepository
